import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/index.vue'

Vue.use(Router)

export default new Router({
  mode: "history",
  base: '/caliber/',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js